import { RouteObject } from 'react-router-dom';
import VerifyInvitationRoute, {
  loader as verifyInvitationLoader,
} from '@/portal/routes/verify-invitation/Route.tsx';
import VerifyInvitationError from '@/portal/routes/verify-invitation/Error.tsx';
import RegistrationRoute, {
  loader as registrationLoader,
  action as registrationAction,
} from '@/portal/routes/registration/Route.tsx';
import LoginRoute, {
  action as loginAction,
} from '@/portal/routes/login/Route.tsx';

export const unauthenticatedRoutes: RouteObject[] = [
  {
    path: 'verify-invitation',
    element: <VerifyInvitationRoute />,
    loader: verifyInvitationLoader,
    errorElement: <VerifyInvitationError />,
  },
  {
    path: 'registration',
    element: <RegistrationRoute />,
    loader: registrationLoader,
    action: registrationAction,
  },
  {
    path: 'login',
    element: <LoginRoute />,
    action: loginAction,
  },
];
